import { styled } from "@mui/material/styles";
import { StyledAnimatedSkeleton } from "shared/components/ModuleSkeleton/components/ModuleHeaderSkeleton/styled";

export const SkeletonCard = styled(StyledAnimatedSkeleton)`
  height: 127px;
  width: 175px;
`;
